import React from 'react';
import { Calendar, Loader2 } from 'lucide-react';

export default function BookingEmptyState({ items, connected }) {
  if (items === null) {
    return (
      <div className="rounded-xl border border-[#E3E2E0] bg-white px-6 py-14 text-center">
        <Loader2 className="w-7 h-7 animate-spin text-[#11C8D8] mx-auto" />
        <h2 className="mt-3 text-base font-semibold text-[#191919]">Loading bookings</h2>
        <p className="mt-1 text-sm text-[#6B6B6B]">Checking local bookings and Google Calendar events.</p>
      </div>
    );
  }

  if (items.length !== 0) return null;

  return (
    <div className="border border-dashed border-[#BFEFEB] bg-[#F8FEFD] rounded-xl py-16 px-6 text-center">
      <Calendar className="w-9 h-9 mx-auto text-[#12AFA8]" />
      <h2 className="mt-3 text-base font-semibold text-[#191919]">No bookings yet</h2>
      <p className="mt-1 text-sm text-[#6B6B6B]">
        {connected
          ? 'Create a test booking to verify MongoDB, Google Calendar sync, and Meet link generation.'
          : 'Connect Google Calendar first, then create a booking to test the full flow.'}
      </p>
    </div>
  );
}
